// @flow

import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import ConfirmBox from 'app/components/commons/ConfirmBox';

type Props = {
  classes: Object,
  onConfirm: () => void,
  onCancel: () => void,
  className?: string,
};

const defaultProps = {
  className: '',
};

function FriendConfirmBox({ classes, onConfirm, onCancel, className }: Props) {
  return (
    <div className={classNames(classes.confirm, className)}>
      <ConfirmBox className={classes.box} onConfirm={onConfirm} onCancel={onCancel} gap={40} />
    </div>
  );
}

FriendConfirmBox.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    confirm: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      borderTop: {
        color: theme.color.white,
        width: 1,
        style: 'solid',
      },
      backgroundColor: theme.color.white,
      color: theme.color.basis4,
    },
    box: {},
  };
}

export default useSheet(applyStyles)(FriendConfirmBox);
